"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNavigator = exports.getDocument = exports.getWindow = void 0;
const utils_1 = require("../utils");
function getWindow() {
    if ((0, utils_1.isRunningOnServer)()) {
        return undefined;
    }
    // eslint-disable-next-line no-restricted-globals
    return window;
}
exports.getWindow = getWindow;
function getDocument() {
    if ((0, utils_1.isRunningOnServer)()) {
        return undefined;
    }
    // eslint-disable-next-line no-restricted-globals
    return document;
}
exports.getDocument = getDocument;
function getNavigator() {
    if ((0, utils_1.isRunningOnServer)()) {
        return undefined;
    }
    // eslint-disable-next-line no-restricted-globals
    return navigator;
}
exports.getNavigator = getNavigator;
//# sourceMappingURL=browser-accessors.js.map